import ViewportMgr from 'coreClasses/view/ViewportMgr';

import {ECarouselDirection, ConfigType} from 'brandComponents/Carousel';

const systemBreakPoints = ViewportMgr.getBreakpointsMap();

export const CAROUSEL_CONFIG: ConfigType = {
	loop: false,
	direction: ECarouselDirection.HORIZONTAL,
	slidesPerView: 2,
	spaceBetween: 16,
	slidesOffsetBefore: 0,
	slidesOffsetAfter: 0,
	resistance: true,
	resistanceRatio: 0,
	duplicateSlides: {
		enabled: false,
		slidesNumber: 0,
	},
	scrollBarConfig: {
		draggable: true,
		dragSize: 'auto',
		horizontalClass: 'd-none',
	},
	navigationConfig: {
		enabled: true,
		nextBtnIcon: 'arrow-right',
		prevBtnIcon: 'arrow-left',
	},
	breakpoints: {
		[systemBreakPoints.lg]: {
			slidesPerView: 4,
			spaceBetween: 32,
		},
	},
};

export const CAROUSEL_CONFIG_BIG_TILE: ConfigType = {
	loop: false,
	direction: ECarouselDirection.HORIZONTAL,
	slidesPerView: 2,
	slidesOffsetBefore: 0,
	slidesOffsetAfter: 0,
	spaceBetween: 16,
	resistance: true,
	resistanceRatio: 0,
	scrollBarConfig: {
		hide: false,
		horizontalClass: 'd-none',
	},
	customClassName: 'swiper-big-tile',
	duplicateSlides: {
		enabled: false,
		slidesNumber: 0,
	},
	navigationConfig: {
		enabled: true,
		nextBtnIcon: 'arrow-right',
		prevBtnIcon: 'arrow-left',
	}
};
